/**
 * clampToFirestoreMs — clamp a millisecond timestamp to Firestore's valid range.
 *
 * Firestore Timestamps only accept seconds within [-62135596800, 253402300799]
 * (year 1 to 9999). The app uses 8640000000000000 (max JS Date, year 275760)
 * as an "all time / no end date" sentinel — sending that to a Firestore query
 * throws server-side. Clamp before it reaches any query.
 *
 * Mirrored in functions/data/fetchHierarchyData.js for the Cloud Function side.
 */
const FIRESTORE_MIN_MS = -62135596800000
const FIRESTORE_MAX_MS = 253402300799999

/**
 * @param {number|*} ms - milliseconds since epoch; non-numbers pass through unchanged
 * @returns {number|*} the clamped milliseconds, or the input as-is when not a number
 */
const clampToFirestoreMs = (ms) => {
    if (typeof ms !== 'number' || Number.isNaN(ms)) return ms
    return Math.min(Math.max(ms, FIRESTORE_MIN_MS), FIRESTORE_MAX_MS)
}

export { FIRESTORE_MIN_MS, FIRESTORE_MAX_MS }
export default clampToFirestoreMs
